import React, { Component } from "react";
import { addMinutes, subMinutes } from "date-fns";
import { observable } from "mobx";
import { observer } from "mobx-react";

import { Mode } from "@formant/core/model/IImageViewConfiguration";
import { IStreamData } from "@formant/core/model/IStreamData";

import { observeStore, queryStore } from "../../../stores";
import { IBaseModuleProps } from "../IBaseModuleProps";
import { Module } from "../Module";
import { findConfiguration } from "../utils/findConfiguration";
import { DeviceView } from "./DeviceView";
import * as styles from "./index.scss";
import { ModeSelector } from "./ModeSelector";
import { TimeView } from "./TimeView";

@observer
export class ImageModule extends Component<IBaseModuleProps> {
    @observable
    private viewMode: Mode = "device";
    private data: IStreamData<"image">[] = [];

    public componentDidMount() {
        const { streamName, configuration } = this.props;

        const { mode } = findConfiguration(
            configuration,
            streamName,
            "image",
        ) || {
            mode: undefined,
        };
        if (mode) {
            this.viewMode = mode;
        }
    }

    public render() {
        const {
            filter,
            streamName,
            hovering,
            hideDevice,
            fullscreen,
            onSelectTime,
        } = this.props;
        const { viewMode } = this;
        const { time, mode } = observeStore;
        const live = mode === "live";

        const startTime = subMinutes(time, 1);
        const endTime = addMinutes(time, 1);

        const queryData = queryStore.moduleQuery(
            filter,
            streamName,
            "image",
            startTime,
            endTime,
        );

        const loading = queryData === undefined;

        this.data = (queryData !== "too much data" && queryData) || this.data;
        const data = this.data;

        const empty = data.length === 0;

        const viewProps = {
            data,
            time,
            live,
            onSelectTime,
            hovering,
            fullscreen,
        };

        return (
            <Module
                {...this.props}
                loading={loading}
                empty={empty}
                type="image"
                className={styles["image-module"]}
            >
                {viewMode === "time" && <TimeView {...viewProps} />}
                {viewMode === "device" && <DeviceView {...viewProps} />}
                {!hideDevice && (
                    <div className={styles.configuration}>
                        <ModeSelector
                            mode={viewMode}
                            onChange={this.onChangeMode}
                        />
                    </div>
                )}
            </Module>
        );
    }

    private onChangeMode = async (mode: Mode) => {
        this.viewMode = mode;

        const { streamName, onChangeConfiguration } = this.props;

        if (!onChangeConfiguration) {
            return;
        }

        onChangeConfiguration({
            streamName,
            type: "image",
            updates: { mode },
        });
    };
}
